/**
 * EventBus — minimaler Pub/Sub für lose gekoppelte Module.
 *
 * WARUM: Screens müssen nicht direkt Services kennen, sondern hören auf Events.
 * Beispiel: socketService emittet 'lobby:updated' → lobbyScreen reagiert.
 */
class EventBus {
  constructor() { this.listeners = new Map(); }

  on(event, handler) {
    if (!this.listeners.has(event)) this.listeners.set(event, new Set());
    this.listeners.get(event).add(handler);
    return () => this.off(event, handler);   // Cleanup-Funktion zurückgeben
  }

  off(event, handler) {
    this.listeners.get(event)?.delete(handler);
  }

  emit(event, payload) {
    const handlers = this.listeners.get(event);
    if (!handlers) return;
    for (const h of handlers) {
      try { h(payload); }
      catch (err) { console.error(`[EventBus] ${event}:`, err); }
    }
  }

  clear(event) {
    if (event) this.listeners.delete(event);
    else this.listeners.clear();
  }
}

export const eventBus = new EventBus();
